import {
  MessageResponseDto,
  GetPatientDto,
  PatientControllerGet200Response,
  PatientApiFp,
  DeletePatientDto,
  CreatePatientBaseDto,
  EditPatientBaseDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponsePatientModel = PatientControllerGet200Response;
export type GetPatientModel = GetPatientDto;
export type MutateResponsePatientModel = MessageResponseDto;
export type CreatePatientModel = CreatePatientBaseDto;
export type UpdatePatientModel = EditPatientBaseDto;
export type DeletePatientModel = DeletePatientDto;

export interface CreatePatientModelExtension {
  patient: CreatePatientModel;
  file: File;
}

export interface UpdatePatientModelExtension {
  patient: UpdatePatientModel;
  file: File;
}

export const apiPatientFp = PatientApiFp(apiConfig);
export const getPatientController = apiPatientFp.patientControllerGet;
export const createPatientController = apiPatientFp.patientControllerCreate;
export const updatePatientController = apiPatientFp.patientControllerEdit;
export const deletePatientController = apiPatientFp.patientControllerDelete;

export const QueryKeyPatient = QueryKey.Patient;
